import { Config } from '../../node_modules/@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: 'e6fd360c-7c04-4d8b-8336-9aeb65cc8a2c',
  redirectUri: 'https://rfm-ui-dev.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  sendExternalEmail: false,
  msGraphUrl: 'https://graph.microsoft.com/v1.0/',
  apiEndpoint: 'https://rfm-api-dev.azure.chevron.com',
  webUrl: 'https://rfm-ui-dev.azure.chevron.com',
};
